import '@assets/styles/tiptap-preview.css';

import { handleApiResponse } from '@src/api/apiClient/axiosClient';
import { supportServiceApiClient } from '@src/api/tenant/supportService/supportServiceApiClient';
import { SupportService } from '@src/api/types/supportService';
import SupportServiceContent from '@src/features/shared/supportService/SupportServiceContent';
import { TENANT_URL } from '@src/routes/tenant';
import React, { useEffect, useState } from 'react';
import { generatePath, useParams } from 'react-router-dom';

const SupportServicePreview: React.FC = () => {
  const { uuid } = useParams<{ uuid: string }>();
  const [supportService, setSupportService] = useState<SupportService | undefined>(undefined);

  const shareData = supportService
    ? {
        url: `${window.location.origin}${generatePath(TENANT_URL.SUPPORT_SERVICES_PREVIEW, { uuid: uuid })}`,
        title: supportService.title,
        tags: supportService.support_service_tags
          ? supportService.support_service_tags.map((tag) => tag.name)
          : [],
        disabled: true,
      }
    : null;

  useEffect(() => {
    const fetchData = async () => {
      if (!uuid) {
        return;
      }

      const res = await supportServiceApiClient.findPreviewBySupportServicePreviewUuid(uuid);
      handleApiResponse(res, async (data) => {
        setSupportService(data);
      });
    };

    fetchData();
  }, [uuid]);

  return (
    <main className='pb-16 pt-10 md:pt-4'>
      <div className='m-auto max-w-[740px] lg:px-6'>
        {supportService && (
          <SupportServiceContent
            supportService={supportService}
            shareData={shareData}
          />
        )}
      </div>
    </main>
  );
};

export default SupportServicePreview;
